import { Search } from 'flowbite-react-icons/outline';
import PropTypes from 'prop-types';

SearchBar.propTypes = {
  onSearch: PropTypes.func,
};

export default function SearchBar({ onSearch }) {
  function handleSearch(event) {
    const searchValue = event.target.value;
    if (onSearch)
      onSearch(searchValue);
  }

  return (
    <label className="input input-bordered flex items-center gap-2">
      <input
        onChange={handleSearch}
        type="text"
        className="grow"
        placeholder="Search"
      />
      <Search />
    </label>
  );
}
